import apiClient from './client';
import type { PermissionGroupDefinition } from '@genealogy-app/shared';

export interface Role {
  id: string;
  name: string;
  description: string | null;
  permissions: string[];
  isSystem: boolean;
  userCount?: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRoleInput {
  name: string;
  description?: string | null;
  permissions: string[];
}

export type UpdateRoleInput = Partial<CreateRoleInput>;

export interface PermissionsCatalog {
  groups: PermissionGroupDefinition[];
  all: string[];
}

export async function fetchRoles(): Promise<Role[]> {
  const { data } = await apiClient.get<Role[]>('/roles');
  return data;
}

export async function fetchPermissionCatalog(): Promise<PermissionsCatalog> {
  const { data } = await apiClient.get<PermissionsCatalog>('/roles/permissions');
  return data;
}

export async function createRole(input: CreateRoleInput): Promise<Role> {
  const { data } = await apiClient.post<Role>('/roles', input);
  return data;
}

export async function updateRole(id: string, input: UpdateRoleInput): Promise<Role> {
  const { data } = await apiClient.patch<Role>(`/roles/${id}`, input);
  return data;
}

export async function deleteRole(id: string): Promise<void> {
  await apiClient.delete(`/roles/${id}`);
}

/** Rollen eines Nutzers FÜR EINEN STAMMBAUM setzen (ersetzt nur dessen Zuweisungen). */
export async function assignUserRoles(
  userId: string,
  treeId: string,
  roleIds: string[],
): Promise<void> {
  await apiClient.put(`/users/${userId}/roles`, { treeId, roleIds });
}
